import { TAbortErrorFactory } from '../types';

export const createAbortError: TAbortErrorFactory = () => new DOMException('', 'AbortError');
